import { Typography, Button } from '@acme/web-ui-kit';
import { useTranslation } from 'react-i18next';
import Divider from 'src/components/Divider';

import styles from './ErrorMessage.module.scss';

function ErrorMessage() {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Divider className={styles.divider} />

      <div className={styles.content}>
        <div className={styles.icon} />

        <Typography variant="H4Normal" className={styles.description}>
          {t('payform.unknown_error.title')}
        </Typography>
      </div>

    </div>
  );
}

export default ErrorMessage;
